export default "__VITE_ASSET__4982667c__"